import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin( ScrollTrigger );

window.gsap = gsap;
window.ScrollTrigger = ScrollTrigger;
